import { render, staticRenderFns } from "./detailedReportHeader.vue?vue&type=template&id=d93078c2&scoped=true"
import script from "./detailedReportHeader.vue?vue&type=script&lang=js"
export * from "./detailedReportHeader.vue?vue&type=script&lang=js"
import style0 from "./detailedReportHeader.vue?vue&type=style&index=0&id=d93078c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93078c2",
  null
  
)

export default component.exports